<template>
  <div class="c-home-care-img-with-text">
    <div class="box">
      <div class="box__img">
        <home-care-img :mt="false" :mb="false" :type="imgType" v-if="imgType !== ''"/>
      </div>

      <div class="box__wording">
        <paragraph :wording="wording" />
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import HomeCareImg from '@/components/Global/HomeCareImg.vue';
import Paragraph from '@/components/Global/Paragraph.vue';

export default defineComponent({
  name: 'HomeCareImgWithText',
  components: {
    HomeCareImg,
    Paragraph,
  },
  props: {
    imgType: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    wording: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
<style lang="scss" scoped>
.c-home-care-img-with-text {
  margin-top: 50px;
  width: 100%;
  // margin-left: auto;
  // margin-right: auto;
  // max-width: 700px;
}
.box {
  // @include flex(center, center, column);
  @include flex(flex-start, flex-start, column);

  &__img {
    margin-right: 30px;
  }

  &__wording {
  }
}

@media screen and (min-width: $tablet) {
  .c-home-care-img-with-text {
    margin-top: 50px;
    width: 100%;
    // @include flex(center);
    margin-left: auto;
    margin-right: auto;
    max-width: 700px;
  }

  .box {
    @include flex(flex-start, flex-start);
  }
}
</style>
